import script from "./Drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./Drawer.vue?vue&type=script&setup=true&lang=js"

import "./Drawer.vue?vue&type=style&index=0&id=1015712a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1015712a"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QList,QItem,QImg,QItemSection,QExpansionItem,QIcon});qInstall(script, 'directives', {Ripple});
